import cookies from 'js-cookie';
import $ from 'jquery';

$( () => {
	const cookieName = 'CONSENTMGR',
	cookieExpire = 60,
	$consentBox = $( '#tiGDPRecModal' );
	var gdprCookies = cookies.withConverter({
		read: function (value, name) {
			return decodeURI(value.toString());
		},
		write: function (value, name) {
			return encodeURI(value.toString());
		}
	});

	function setPreferencesValues() {
		var cookieData={ts:new Date().getTime(),consent:true,c1:1,c2:1,c3:1,c4:1,c5:1,c6:1,c7:1,c8:1,c9:1,c10:1,c11:1,c12:1,c13:1,c14:1,c15:1};
		setCookie(cookieData);
	}

	function getDomainName(hostName) {
		return hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1));
	}

	function setCookie(cookieData) {
		var mo2Val: string[]= [];
		for(var i in cookieData) {
			mo2Val.push(i + ":" + cookieData[i]);
		}
		var expires=new Date();
		expires.setDate(expires.getDate() + cookieExpire);
		var cookieValue = (mo2Val.join("|"));
		gdprCookies.set( cookieName, cookieValue, {
			domain: getDomainName(window.location.hostname),
			expires,
			path: '/'
		} );
	}
	
	function refreshCookie() {
		setCookie(getGDPRCookieValues());
	}
	
	function getGDPRCookieValues() {
		var values={}; 
		try{
			var cookieData =  gdprCookies.get(cookieName);
			if(cookieData){
				var i,optOut,optOutData=(cookieData).split("|");
				for(i=0;i<optOutData.length;i++){
					optOut=optOutData[i].split(":");
					values[optOut[0]]=optOut[1];
				}
			}
		}catch(e){}
		return values;
	}
	
	function loadGACode() {
		if(cookies.get( cookieName )) {
			if(cookies.get( cookieName ).indexOf("c1:1") >= 0) {
				var scripts = document.getElementsByTagName("script")[0];
				var script = document.createElement("script");				
				script.type = "text/javascript",
				script.async = !0,
				script.src = "/App_Themes/v2/js/t3europe/analytics.js",
				scripts.parentNode.insertBefore(script, scripts);
			}
		}
	}

	if(cookies.get( cookieName )) {
		refreshCookie();
	}

	if( !$consentBox.length ) return;
	$consentBox.toggle( !cookies.get( cookieName ) );
	

	$consentBox.on( 'click', '#consent_prompt_submit', e => {
		e.preventDefault();
		setPreferencesValues();		
		$consentBox.hide();
		loadGACode();
		//location.reload();
	} );

	$consentBox.on( 'click', '#privacy_link_optin', e => {
		//e.preventDefault();
		//setPreferencesValues();
		//$cookieBox.hide();
	} );

	$consentBox.on( 'click', '#consent_pref_center', e => {
		//e.preventDefault();
		//setPreferencesValues();
		//$consentBox.hide();
	} );
} );
